import React from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { sendCodeTelephone } from "src/app/api/PublicApi";
import { useAppState } from "src/app/state/StateProvider";
import CodeTelephoneSendFormContent from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/CodeTelephoneSendFormContent";
import useValidationSchemaTelephone, { VerificationTelephone } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/useValidationSchemaTelephone";

export type VerificationTelephoneFormProps = {
  initialValues: VerificationTelephone;
  pageSuivante?: (data: any) => void;
  submitSuccessHandler: (result: GenericApiResponse<any>, values: FormikValues) => void;
  canSkip?: boolean;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};


const CodeTelephoneSendForm = ({ initialValues, pageSuivante, submitSuccessHandler, canSkip, displayCancelBtn, cancelCallback }: VerificationTelephoneFormProps) => {
  const [{ langue }] = useAppState();
  const validationSchema = useValidationSchemaTelephone();

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={(values: VerificationTelephone) => sendCodeTelephone(values, langue)}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
    >
      <CodeTelephoneSendFormContent pageSuivante={pageSuivante} canSkip={canSkip} displayCancelBtn={displayCancelBtn} cancelCallback={cancelCallback} />
    </AppFormik>
  );
};

export default CodeTelephoneSendForm;